export const GET_CAPPING_LIMIT = 'GET_CAPPING_LIMIT';
export const LIMIT_UPDATED = 'LIMIT_UPDATED';
export const FAILED_TO_UPDATE_LIMIT = 'FAILED_TO_UPDATE_LIMIT';